import React, { useState } from 'react'
import bannerend from '../../assets/images/shape8.png'
import { Col, Row } from 'antd'
import { packageData } from './packageData'
import like from '../../assets/images/Frame 2056.png'
import DomestDetails from './DomestDetails'
import LetterPad from '../LetterPad'


const DomestList = () => {

  const [activeTab , setActiveTab] = useState(false);
  const [details , setDetails] = useState('')


  return (
    <>
      <div className='domesticPackage-banner'>
        <div className='packageBanner'>
          {/* <img src={bannerend} alt='' className='bottomImg' style={{ rotate: "180deg" }} /> */}
          <h1>Domestic Packages</h1>
        </div>

      </div>

      <div className='domesticPackageList'>
        <h4>Destinations</h4>
        <h1><span>Explore</span> Top Destinations</h1>
        <p>Discover the world’s most captivating destinations with Travelance Holidays – from vibrant cities to peaceful retreats.</p>


        {activeTab ?
        <DomestDetails setActiveTab={setActiveTab} details={details}/> : <div className='pacakages-lists'>
          <Row gutter={[20, 30]}>
            {packageData.map((item , index) =>
              <Col key={index} xs={24} sm={24} md={12} lg={8} xl={6}>

                <section className="cards" onClick={() => {setActiveTab(true); setDetails(item)}}>
                {/* <Link to={`${item.place}`}> */}
                  <article className="card card--1">
                    <div className="card__info-hover">
                      {/* <div className="feature">
                        Popular
                      </div> */}
                      {/* <div className="price">
                        <h3>$450</h3>
                        <h3 style={{ fontSize: 14, fontWeight: 400 }}>/hr</h3>
                      </div> */}

                    </div>
                    <div className="card__img"></div>
                    <div className="card_link">
                      <div className="card__img--hover" style={{ backgroundImage: `url(${item.img})` }}></div>
                    </div>
                    <div className="card__info">
                      <div className="card-hero">
                        <div className="card-top">
                          <div className="cardReview">
                            <div className="showReview">
                              4.5
                            </div>
                            <p>120 Reviews</p>
                          </div>
                          <div>
                            <img src={like} alt="" />
                          </div>
                        </div>
                        <div className="card-medium">
                          <h6>{item.place}</h6>
                          <p>Travelance</p>
                          <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M8 1.33333C6.58551 1.33333 5.22895 1.89524 4.22876 2.89543C3.22856 3.89562 2.66666 5.25218 2.66666 6.66667C2.66666 8.73204 4.01049 10.7362 5.48396 12.2915C6.20707 13.0548 6.93244 13.6796 7.47778 14.1139C7.68074 14.2755 7.85801 14.4101 7.99999 14.5151C8.14198 14.4101 8.31925 14.2755 8.52221 14.1139C9.06755 13.6796 9.79292 13.0548 10.516 12.2915C11.9895 10.7362 13.3333 8.73204 13.3333 6.66667C13.3333 5.25218 12.7714 3.89562 11.7712 2.89543C10.771 1.89524 9.41448 1.33333 8 1.33333ZM8 15.3333C7.6302 15.888 7.63003 15.8879 7.62983 15.8878L7.62793 15.8865L7.62349 15.8835L7.60821 15.8732C7.59523 15.8644 7.57671 15.8517 7.55303 15.8353C7.50568 15.8025 7.43764 15.7547 7.35186 15.6928C7.18036 15.5689 6.93757 15.3881 6.64721 15.1569C6.06755 14.6954 5.29292 14.0286 4.51603 13.2085C2.9895 11.5972 1.33333 9.26796 1.33333 6.66667C1.33333 4.89856 2.03571 3.20286 3.28595 1.95262C4.53619 0.702379 6.23188 0 8 0C9.7681 0 11.4638 0.702379 12.714 1.95262C13.9643 3.20286 14.6667 4.89856 14.6667 6.66667C14.6667 9.26796 13.0105 11.5972 11.484 13.2085C10.7071 14.0286 9.93244 14.6954 9.35278 15.1569C9.06242 15.3881 8.81963 15.5689 8.64813 15.6928C8.56235 15.7547 8.49431 15.8025 8.44696 15.8353C8.42328 15.8517 8.40476 15.8644 8.39178 15.8732L8.3765 15.8835L8.37206 15.8865L8.37065 15.8875C8.37046 15.8876 8.36979 15.888 8 15.3333ZM8 15.3333L8.36979 15.888C8.14586 16.0373 7.85377 16.0371 7.62983 15.8878L8 15.3333Z" fill="#A0A0A0" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.99999 5.33333C7.26362 5.33333 6.66666 5.93029 6.66666 6.66667C6.66666 7.40305 7.26362 8 7.99999 8C8.73637 8 9.33333 7.40305 9.33333 6.66667C9.33333 5.93029 8.73637 5.33333 7.99999 5.33333ZM5.33333 6.66667C5.33333 5.19391 6.52724 4 7.99999 4C9.47275 4 10.6667 5.19391 10.6667 6.66667C10.6667 8.13943 9.47275 9.33333 7.99999 9.33333C6.52724 9.33333 5.33333 8.13943 5.33333 6.66667Z" fill="#A0A0A0" />
                          </svg> <h5 style={{ color: "192335" }}>{item.country}</h5></div>
                          <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path fillRule="evenodd" clipRule="evenodd" d="M3.33333 3.33333C2.96514 3.33333 2.66666 3.63181 2.66666 4V13.3333C2.66666 13.7015 2.96514 14 3.33333 14H12.6667C13.0349 14 13.3333 13.7015 13.3333 13.3333V4C13.3333 3.63181 13.0349 3.33333 12.6667 3.33333H3.33333ZM1.33333 4C1.33333 2.89543 2.22876 2 3.33333 2H12.6667C13.7712 2 14.6667 2.89543 14.6667 4V13.3333C14.6667 14.4379 13.7712 15.3333 12.6667 15.3333H3.33333C2.22876 15.3333 1.33333 14.4379 1.33333 13.3333V4Z" fill="#A0A0A0" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M10.6667 0.666504C11.0349 0.666504 11.3333 0.964981 11.3333 1.33317V3.99984C11.3333 4.36803 11.0349 4.6665 10.6667 4.6665C10.2985 4.6665 10 4.36803 10 3.99984V1.33317C10 0.964981 10.2985 0.666504 10.6667 0.666504Z" fill="#A0A0A0" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M5.33334 0.666504C5.70153 0.666504 6.00001 0.964981 6.00001 1.33317V3.99984C6.00001 4.36803 5.70153 4.6665 5.33334 4.6665C4.96515 4.6665 4.66667 4.36803 4.66667 3.99984V1.33317C4.66667 0.964981 4.96515 0.666504 5.33334 0.666504Z" fill="#A0A0A0" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M1.33333 6.66667C1.33333 6.29848 1.63181 6 1.99999 6H14C14.3682 6 14.6667 6.29848 14.6667 6.66667C14.6667 7.03486 14.3682 7.33333 14 7.33333H1.99999C1.63181 7.33333 1.33333 7.03486 1.33333 6.66667Z" fill="#A0A0A0" />
                            </svg>
                            <h5>Trip Duriation : </h5>
                            <h5 style={{ color: "#097E52",width:"auto" }}>{item.tripDur}</h5>
                          </div>
                        </div>
                        <div className="card-bottom">
                          <div className="bottomProfile">
                          </div>
                          <div className="bookbutton" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                              <path fillRule="evenodd" clipRule="evenodd" d="M3.75 4.25C3.33579 4.25 3 4.58579 3 5V15.5C3 15.9142 3.33579 16.25 3.75 16.25H14.25C14.6642 16.25 15 15.9142 15 15.5V5C15 4.58579 14.6642 4.25 14.25 4.25H3.75ZM1.5 5C1.5 3.75736 2.50736 2.75 3.75 2.75H14.25C15.4926 2.75 16.5 3.75736 16.5 5V15.5C16.5 16.7426 15.4926 17.75 14.25 17.75H3.75C2.50736 17.75 1.5 16.7426 1.5 15.5V5Z" fill="#192335" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V5C12.75 5.41421 12.4142 5.75 12 5.75C11.5858 5.75 11.25 5.41421 11.25 5V2C11.25 1.58579 11.5858 1.25 12 1.25Z" fill="#192335" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M6 1.25C6.41421 1.25 6.75 1.58579 6.75 2V5C6.75 5.41421 6.41421 5.75 6 5.75C5.58579 5.75 5.25 5.41421 5.25 5V2C5.25 1.58579 5.58579 1.25 6 1.25Z" fill="#192335" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M1.5 8C1.5 7.58579 1.83579 7.25 2.25 7.25H15.75C16.1642 7.25 16.5 7.58579 16.5 8C16.5 8.41421 16.1642 8.75 15.75 8.75H2.25C1.83579 8.75 1.5 8.41421 1.5 8Z" fill="#192335" />
                            </svg>
                            <p style={{ margin: 0 }}>Book Now</p>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </article>
                  {/* </Link> */}
                </section>   </Col>
            )}
          </Row>
        </div>}
      </div>

<LetterPad />
    </>
  )
}

export default DomestList